
const params = (function () {
	const obj:{[key: string]: string} = {};
	if (!window) return obj;
  const str = window.location.search || '';
  if (str && str.slice(1)) {
    let queryArray = str.slice(1).split('&');
    queryArray.map((query) => {
      const temp = query.split('=');
      if(temp.length > 1) {
        obj[temp[0]] = temp[1];
      }
    })
  }
	return obj;
})();

/**
 * 获取请求路径参数
 * @param param 
 * @returns 
 */
export const getQueryParam = (param: string) => {
  return params[param] || '';
}